import { Modal, Button, Card, Input, ModalBody, ModalFooter } from "reactstrap";
import { useRef, useState } from "react";
import AvatarEditor from "react-avatar-editor";
import { FcAddImage } from "react-icons/fc";
import "./avatar.scss";

const CropperModal = ({ src, modalOpen, setModalOpen, setPreview, setIsDisable }) => {
    const [slideValue, setSlideValue] = useState(10);
    const cropRef = useRef(null);

    const handleSave = async () => {
        if (cropRef) {
            const dataUrl = cropRef.current.getImage().toDataURL();
            const result = await fetch(dataUrl);
            const blob = await result.blob();
            setPreview(URL.createObjectURL(blob));
            setModalOpen(false);
            setIsDisable(false)
        }
    };

    return (
        <Modal isOpen={modalOpen} size="sm">
            <ModalBody>
                <AvatarEditor
                    ref={cropRef}
                    image={src}
                    style={{ width: "100%", height: "100%" }}
                    border={50}
                    borderRadius={150}
                    color={[0, 0, 0, 0.72]}
                    scale={slideValue / 10}
                    rotate={0}
                />

                <Input
                    className="mt-2"
                    type="range"
                    min={10}
                    max={50}
                    size="medium"
                    defaultValue={slideValue}
                    value={slideValue}
                    onChange={(e) => setSlideValue(e.target.value)}
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    color="link"
                    onClick={(e) => setModalOpen(false)}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={handleSave}
                >
                    Save
                </Button>
            </ModalFooter>
        </Modal >
    );
};

const Avatar = ({ setIsDisable, src, setSrc, profile_image }) => {

    const [preview, setPreview] = useState(profile_image ? profile_image : null);
    const [modalOpen, setModalOpen] = useState(false);

    const inputRef = useRef(null);

    const handleInputClick = (e) => {
        e.preventDefault();
        inputRef.current.click();
    };

    const handleImgChange = (e) => {
        setSrc(e.target.files[0]);
        setModalOpen(true);
    };

    return (
        <>
            <main className="container">
                <CropperModal
                    modalOpen={modalOpen}
                    src={src}
                    setPreview={setPreview}
                    setModalOpen={setModalOpen}
                    setIsDisable={setIsDisable}
                />
                <a href="/" onClick={handleInputClick}>
                    <FcAddImage className="add-icon" />
                </a>
                <small>Click to select image</small>
                <input
                    type="file"
                    accept="image/*"
                    ref={inputRef}
                    onChange={handleImgChange}
                />
                <div className="img-container">
                    <img
                        src={
                            preview ||
                            " https://www.signivis.com/img/custom/avatars/member-avatar-01.png"
                        }
                        alt=""
                        width="150"
                        height="150"
                    />
                </div>
            </main>
        </>
    );
};

export default Avatar;
